import React, { useEffect, useState } from 'react';
import { publicApi, getMediaUrl } from '../services/api';

const fallbackBlogs = [
  {
    id: '1',
    image: '/assets/images/blog/blog-1-1.jpg',
    date: '10',
    month: 'Aug',
    author: 'Dr. Sarah Johnson',
    title: 'Building Resilience in Tough Times',
    excerpt: 'Learn practical cognitive strategies and daily habits to develop emotional resilience and recover from burnout.',
    category: 'Mental Health',
    readTime: '4 min read'
  },
  {
    id: '2',
    image: '/assets/images/blog/blog-1-2.jpg',
    date: '10',
    month: 'Aug',
    author: 'Dr. Michael Chen',
    title: 'Work-Life Balance: Myth or Reality?',
    excerpt: 'Discover evidence-based methods to set healthy boundaries between high-demand careers and your personal life.',
    category: 'Wellness Guide',
    readTime: '5 min read'
  },
  {
    id: '3',
    image: '/assets/images/blog/blog-1-3.jpg',
    date: '10',
    month: 'Aug',
    author: 'Pooja Jagyasi',
    title: "Supporting a Child's Mental Health",
    excerpt: 'A comprehensive guide for parents and educators on identifying emotional distress and nurturing early confidence.',
    category: 'Family Care',
    readTime: '6 min read'
  }
];

function ArticlesSection() {
  const [blogs, setBlogs] = useState(fallbackBlogs);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const data = await publicApi.getBlogs({ limit: 3 });
        const list = data?.blogs || data?.data || (Array.isArray(data) ? data : []);

        if (Array.isArray(list) && list.length > 0) {
          const fallbackImages = [
            '/assets/images/blog/blog-1-1.jpg',
            '/assets/images/blog/blog-1-2.jpg',
            '/assets/images/blog/blog-1-3.jpg'
          ];

          const mapped = list.slice(0, 3).map((item, index) => {
            const d = item.createdAt ? new Date(item.createdAt) : new Date();
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

            // Resolve image from database (uploads or external url)
            const rawImg = item.featuredImage || item.image || item.coverImage;
            let imgSrc = fallbackImages[index % fallbackImages.length];
            if (rawImg && !String(rawImg).includes('via.placeholder.com')) {
              imgSrc = getMediaUrl(rawImg) || imgSrc;
            }

            const authorObj = item.createdBy || {};
            const authorName = typeof authorObj === 'object' ? (authorObj.name || 'PsychMitra Expert') : 'PsychMitra Expert';

            return {
              id: item._id || index,
              image: imgSrc,
              date: d.getDate().toString(),
              month: months[d.getMonth()],
              author: authorName,
              title: item.title || 'Mental Health Article',
              excerpt: item.excerpt || (item.content ? item.content.slice(0, 110) + '...' : 'Insights and guidance for psychological wellness.'),
              category: item.category || 'Mental Health',
              readTime: `${Math.max(3, Math.ceil((item.content?.length || 500) / 250))} min read`
            };
          });

          setBlogs(mapped);
        }
      } catch (err) {
        console.error('Error fetching dynamic blogs from database:', err);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <section className="articles-modern-section" style={{ padding: '95px 0 85px', backgroundColor: '#faf8fe', position: 'relative' }}>
      <div className="container">
        {/* Section Header */}
        <div className="section-title text-center" style={{ marginBottom: '50px' }}>
          <span
            style={{
              display: 'inline-block',
              backgroundColor: 'rgba(124, 75, 185, 0.1)',
              color: '#7c4bb9',
              fontSize: '12px',
              fontWeight: 700,
              letterSpacing: '1.8px',
              textTransform: 'uppercase',
              padding: '6px 18px',
              borderRadius: '20px',
              marginBottom: '10px'
            }}
          >
            KNOWLEDGE &amp; RESOURCES
          </span>
          <h2 className="section-title__title" style={{ fontSize: '38px', marginTop: '6px' }}>
            Articles &amp; <span style={{ color: '#7c4bb9' }}>Blogs</span>
          </h2>
          <p style={{ maxWidth: '620px', margin: '12px auto 0', color: '#666666', fontSize: '15px', lineHeight: '1.6' }}>
            Insights, evidence-based coping strategies, and mental wellness guides written by verified psychologists.
          </p>
        </div>

        {/* 3 Column Articles Grid */}
        <div className="row">
          {blogs.map((blog) => (
            <div key={blog.id} className="col-xl-4 col-lg-4 col-md-6 mb-4">
              <article
                className="modern-blog-card"
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '24px',
                  border: '1.5px solid #ece5f8',
                  overflow: 'hidden',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  boxShadow: '0 10px 30px rgba(124, 75, 185, 0.07)',
                  transition: 'transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease'
                }}
              >
                {/* Image Container with Floating Badges */}
                <div style={{ position: 'relative', overflow: 'hidden', height: '220px', backgroundColor: '#f0e9ff' }}>
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="blog-card-img"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                      transition: 'transform 0.5s ease'
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/assets/images/blog/blog-1-1.jpg';
                    }}
                  />

                  {/* Category Badge on Top-Left */}
                  <span
                    style={{
                      position: 'absolute',
                      top: '14px',
                      left: '14px',
                      backgroundColor: 'rgba(124, 75, 185, 0.9)',
                      color: '#ffffff',
                      backdropFilter: 'blur(6px)',
                      padding: '5px 14px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: 600,
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                      zIndex: 2
                    }}
                  >
                    {blog.category}
                  </span>

                  {/* Date Badge on Top-Right */}
                  <span
                    style={{
                      position: 'absolute',
                      top: '14px',
                      right: '14px',
                      backgroundColor: 'rgba(255, 255, 255, 0.92)',
                      color: '#2c194d',
                      backdropFilter: 'blur(6px)',
                      padding: '5px 12px',
                      borderRadius: '16px',
                      fontSize: '12px',
                      fontWeight: 700,
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
                      zIndex: 2
                    }}
                  >
                    <i className="far fa-calendar-alt" style={{ marginRight: '5px', color: '#7c4bb9' }}></i>
                    {blog.date} {blog.month}
                  </span>
                </div>

                {/* Card Content */}
                <div style={{ padding: '24px 26px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                  {/* Reading Time */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#888888', marginBottom: '10px' }}>
                    <i className="far fa-clock" style={{ fontSize: '12px', color: '#7c4bb9' }}></i>
                    <span>{blog.readTime}</span>
                  </div>

                  {/* Title */}
                  <h3 style={{ fontSize: '19px', fontWeight: 700, color: '#2c194d', lineHeight: '1.4', marginBottom: '10px' }}>
                    <a
                      href="/blog"
                      className="blog-title-link"
                      style={{
                        color: 'inherit',
                        textDecoration: 'none',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden'
                      }}
                    >
                      {blog.title}
                    </a>
                  </h3>

                  {/* Excerpt */}
                  <p
                    style={{
                      color: '#666666',
                      fontSize: '14px',
                      lineHeight: '1.6',
                      margin: '0 0 20px 0',
                      flex: 1,
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden'
                    }}
                  >
                    {blog.excerpt}
                  </p>

                  {/* Card Bottom: Author & Read More */}
                  <div
                    style={{
                      borderTop: '1px solid #f0eaf8',
                      paddingTop: '16px',
                      marginTop: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div
                        style={{
                          width: '32px',
                          height: '32px',
                          borderRadius: '50%',
                          backgroundColor: '#f0e9ff',
                          color: '#7c4bb9',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '13px',
                          fontWeight: 700
                        }}
                      >
                        {blog.author.charAt(0)}
                      </div>
                      <span style={{ fontSize: '13px', color: '#555555', fontWeight: 600 }}>
                        {blog.author}
                      </span>
                    </div>

                    <a
                      href="/blog"
                      className="read-more-link"
                      style={{
                        color: '#7c4bb9',
                        fontSize: '13px',
                        fontWeight: 700,
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        transition: 'gap 0.2s ease'
                      }}
                    >
                      Read <i className="fas fa-arrow-right" style={{ fontSize: '11px' }}></i>
                    </a>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>

        {/* View All Articles Button */}
        <div className="text-center" style={{ marginTop: '30px' }}>
          <a
            href="/blog"
            className="thm-btn"
            style={{
              padding: '12px 34px',
              fontSize: '15px',
              borderRadius: '30px',
              boxShadow: '0 8px 24px rgba(124, 75, 185, 0.2)'
            }}
          >
            View All Articles &amp; Blogs <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }}></i>
          </a>
        </div>
      </div>

      <style>{`
        .modern-blog-card:hover {
          transform: translateY(-7px);
          box-shadow: 0 20px 45px rgba(124, 75, 185, 0.16) !important;
          border-color: #7c4bb9 !important;
        }
        .modern-blog-card:hover .blog-card-img {
          transform: scale(1.06);
        }
        .modern-blog-card:hover .blog-title-link {
          color: #7c4bb9 !important;
        }
        .modern-blog-card:hover .read-more-link {
          gap: 8px !important;
          color: #5b2d99 !important;
        }
      `}</style>
    </section>
  );
}

export default ArticlesSection;
